<template>
  <div>
    <page-header title="لیست ویژگی های محصولات" create-url="/specifications/create"></page-header>

    <table-with-pagination v-if="specifications"
                           :items="specifications"
                           :headers="headers"
                           :default-page="parseInt($route.query.page ?? '1')"
                           @fetchPage="getSpecifications"
                           @delete="deleteSpecification"
                           :actions="actions"
    ></table-with-pagination>
  </div>
</template>

<script>
import PageHeader from "@/components/General/PageHeader";
import TableWithPagination from "@/components/General/TableWithPagination";

export default {
  name: "SpecificationList",

  components: {TableWithPagination, PageHeader},

  data() {
    return {
      headers: [
        {text: 'شناسه', value: 'id', align: 'center'},
        {text: 'نام فارسی', value: 'fa_name', align: 'center'},
        {text: 'قابل جستجو', value: 'searchable', align: 'center'},
        {text: 'نوع', value: 'type', align: 'center'},
        {text: 'تاریخ آخرین بروز رسانی', value: 'persian_updated_at', align: 'center'},
        {text: 'تاریخ ایجاد', value: 'persian_created_at', align: 'center'},
        {text: 'عملیات', value: 'actions', align: 'center'},
      ],

      specifications: null,

      actions: [
        {
          icon: 'mdi-pencil',
          color: 'warning',
          route_name: 'update-specification',
          route_param: 'id'
        },
        {
          icon: 'mdi-delete',
          color: 'error',
          emit: 'delete',
          identifier: 'id',
          delete_confirm: true,
        }
      ],
    }
  },

  mounted() {
    this.getSpecifications(parseInt(this.$route.query.page ?? "1"))
  },

  methods: {
    getSpecifications(page = 1) {
      this.$store.dispatch("getSpecifications", page)
          .then((res) => {
            this.specifications = {
              data: res.data
            }
          })
    },

    deleteSpecification(id) {
      this.$store.dispatch("deleteSpecification", id)
          .then(() => {
            this.getSpecifications()
          })
    }
  }
}
</script>

<style scoped>

</style>